export default __webpack_public_path__ + "static/media/sustainableLogo.4833718b.svg";